// extracted by mini-css-extract-plugin
export default {"host":"style_host__V0jki","iconApproved":"style_iconApproved__0Mw9p"};